import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { UpgradeTier } from '../../interceptors/pricing-error.interceptor';
import { EnterpriseRequestService } from '../../services/enterprise-request.service';

@Component({
  selector: 'app-tier-upgrade-dialog',
  standalone: true,
  imports: [CommonModule, ButtonModule, DividerModule],
  templateUrl: './tier-upgrade-dialog.component.html',
  styleUrl: './tier-upgrade-dialog.component.scss'
})
export class TierUpgradeDialogComponent implements OnInit {
  metric = '';
  metricDisplayName = '';
  currentUsage = 0;
  limit = 0;
  upgradeTiers: UpgradeTier[] = [];
  message = '';

  /** Percentage of usage (0-100) for the progress bar */
  usagePercent = 100;

  constructor(
    private dialogRef: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private enterpriseRequestService: EnterpriseRequestService
  ) {}

  ngOnInit(): void {
    const data = this.config.data;
    this.metric = data.metric || '';
    this.metricDisplayName = data.metricDisplayName || this.metric;
    this.currentUsage = data.currentUsage || 0;
    this.limit = data.limit || 0;
    this.upgradeTiers = (data.upgradeTiers || []).filter(
      (t: UpgradeTier) => t.tierId !== 'enterprise'
    );
    this.message = data.message || '';

    // Calculate usage percentage
    this.usagePercent = this.limit > 0
      ? Math.min(Math.round((this.currentUsage / this.limit) * 100), 100)
      : 100;
  }

  /**
   * Format a tier limit value for display
   */
  formatLimit(value: number): string {
    if (value === -1) return 'Unlimited';
    return value.toLocaleString();
  }

  /**
   * Format tier price for display
   */
  formatPrice(price: number): string {
    if (price === 0) return 'Free';
    return `$${price}`;
  }

  /**
   * Check if a tier has an "enterprise" indicator
   */
  hasEnterpriseTier(): boolean {
    return (this.config.data.upgradeTiers || []).some(
      (t: UpgradeTier) => t.tierId === 'enterprise'
    );
  }

  /**
   * User clicked "Upgrade" on a tier card
   */
  selectTier(tierId: string): void {
    this.dialogRef.close({ selectedTierId: tierId });
  }

  /**
   * User clicked "Contact Sales" for enterprise — opens in-app enterprise request dialog
   */
  contactSales(): void {
    // Close the tier upgrade dialog first, then open the enterprise request dialog
    // with context about what metric/usage triggered it
    this.dialogRef.close();
    setTimeout(() => {
      this.enterpriseRequestService.openRequestDialog({
        metric: this.metric,
        currentUsage: this.currentUsage,
        limit: this.limit
      });
    }, 300);
  }

  /**
   * User dismissed the dialog
   */
  dismiss(): void {
    this.dialogRef.close();
  }
}
